module.exports = __webpack_public_path__ + "static/img_dxzm.f261764c.png";